import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return undefined;
  }

  if (profile.interestsNotification) {
    return profile.interestsNotification;
  } else {
    return undefined;
  }
};
//VERIFY IF THE JWT IS SET
const getMyInterestsCount = createSelector(getData, count => count);
export default getMyInterestsCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyInterestsCount.js